import { atom } from "recoil";

const localStorageEffect =
  (key) =>
  ({ setSelf, onSet }) => {
    // Initialize atom from localStorage
    const savedValue = localStorage.getItem(key);
    if (savedValue !== null) {
      setSelf(JSON.parse(savedValue));
    }

    // Subscribe to changes and update localStorage
    onSet((newValue, _, isReset) => {
      if (isReset) {
        localStorage.removeItem(key);
      } else {
        localStorage.setItem(key, JSON.stringify(newValue));
      }
    });
  };

export const teamList = atom({
  key: "teamList",
  default: [],
  effects_UNSTABLE: [localStorageEffect("teams")],
});

export const isOrganizationChanged = atom({
  key: "isOrganizationChanged",
  default: true,
});